import { useEffect } from 'react';

export function useQuickNavShortcut(onOpen: () => void, enabled = true) {
    useEffect(() => {
        if (!enabled) return;

        function handleKey(e: KeyboardEvent) {
            if (!(e.metaKey || e.ctrlKey) || e.key.toLowerCase() !== 'k') return;
            e.preventDefault();
            onOpen();
        }

        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [enabled, onOpen]);
}
